import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {TextField} from '@material-ui/core';
import {AbstractFormComponent, Icon} from 'front-onceforall-core';
import {requiredValidator} from 'front-onceforall-core/dist/utils/validators';

const MAX_LENGTH = 1024;

export class ResendReasonForm extends AbstractFormComponent {
  getFormData() {
    return {
      reason: ''
    };
  }

  getFormValidators() {
    return {
      reason: requiredValidator
    };
  }

  handleSubmitCallback() {
    this.props.onSubmit(this.state.formData);
  }

  render() {
    const valueLength = this.state.formData.reason.length;
    return (
      <>
        <h2 className="m-0"><Translate value="resendInvitationReason.title"/></h2>
        <p><Translate value="resendInvitationReason.explanatory"/></p>
        <form
          className="mt-4 p-0"
          onSubmit={this.handleSubmit}
        >
          <TextField
            autoFocus
            value={this.state.formData.reason}
            onChange={this.handleChange('reason')}
            helperText={this.helperText('reason')}
            error={this.isOnError('reason')}
            label={this.getFieldLabel('resendInvitationReason.reason', true)}
            placeholder={I18n.t('resendInvitationReason.placeholder')}
            multiline
            rows={5}
            inputProps={{
              maxLength: MAX_LENGTH
            }}
          />
          <Translate
            value="message.textCounter"
            counter={this.state.formData.reason ? valueLength : 0}
            maxLength={MAX_LENGTH}
          />

          <div className="actions col-12 inline-container space-between">
            <button
              type="button"
              className="large secondary inline-container"
              onClick={this.props.onClose}
              data-id="cancel"
            >
              <Icon icon="go-back"/>
              <Translate value="action.cancel"/>
            </button>
            <button
              className="large primary inline-container"
              type="submit"
              disabled={this.state.submitting}
            >
              <Icon icon={this.state.submitting ? 'loader' : 'check'}/>
              <Translate value="action.confirm"/>
            </button>
          </div>
        </form>
      </>
    );
  }
}

ResendReasonForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ResendReasonForm;
